import React from "react";
import { withRouter } from "react-router-dom";
import ModalPopup from "../common/ModalPopup";
import PrivacyContent from "./PrivacyContent";

function PrivacyRouteModal({ history }) {
  return (
    <ModalPopup
      isOpen={true}
      toggle={() => history.goBack()}
      title="Privacy Policy"
      footer={false}
      bodyHeight={true}
    >
      <PrivacyContent />
    </ModalPopup>
  );
}

export default withRouter(PrivacyRouteModal);
